import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter, matchPath } from 'react-router';
import { Route, Switch, Link } from 'react-router-dom';
import { injectIntl, intlShape } from 'react-intl';
import { FontIcon } from 'react-md';

import Header from './Header';
import Footer from './Footer';
import AuthenticatedRoute from './AuthenticatedRoute';
import UnauthenticatedRoute from './UnauthenticatedRoute';

import Login from './Login/Login';
import Forgot from './Login/Forgot';
import ChangePassword from './Login/ChangePassword';
import RootPage from './RootPage';
import PsyMain from './PsyMain';
import DriverTabs from './DriverTabs';
import Users from './Users';
import Faq from './FAQ';
import Privacy from './Privacy';

import NotFound from './NotFound';

const adminCheck = childProps => childProps.userAttributes.isAdmin;
const psyCheck = childProps => childProps.userAttributes.isPsy;
const driverCheck = childProps => childProps.userAttributes.isDriver;
const driverOrPsyCheck = childProps => psyCheck(childProps) || driverCheck(childProps);

const navItems = ({ intl }) => [
  {
    path: '/calendar',
    component: DriverTabs,
    title: intl.formatMessage({ id: 'menu.title.calendar' }),
    groupCheck: driverOrPsyCheck,
  },
  {
    path: '/contested',
    component: DriverTabs,
    title: intl.formatMessage({ id: 'menu.title.contested' }),
    groupCheck: driverOrPsyCheck,
  },
  {
    path: '/users',
    component: Users,
    title: intl.formatMessage({ id: 'menu.title.users' }),
    groupCheck: adminCheck,
  },
  {
    path: '/drivers',
    component: PsyMain,
    activeTabIndex: 0,
    title: intl.formatMessage({ id: 'menu.title.drivers' }),
    groupCheck: psyCheck,
  },
  {
    path: '/settings',
    component: ChangePassword,
    title: intl.formatMessage({ id: 'accountMenu.settings' }),
  },
  {
    path: '/faq',
    component: Faq,
    title: intl.formatMessage({ id: 'faq.faq_message.title' }),
  },
  {
    path: '/privacy-policy',
    component: Privacy,
    title: intl.formatMessage({ id: 'privacy.privacy_message.title' }),
  },
];


class Routes extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    childProps: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
  };

  render() {
    const { childProps, intl, location: { pathname } } = this.props;
    const { userAttributes: { isPsy } } = childProps;

    const getNavItem = () => navItems({ intl }).find(e => matchPath(pathname, { ...e }));

    const getCurrentTitle = () => {
      const currentNavItem = getNavItem();
      if (currentNavItem) {
        const { title, component } = currentNavItem;
        if (isPsy && (component === DriverTabs /* || component === Stats || component === Errors */)) {
          const currentDriver = localStorage.currentDriverName;
          return (
            <span>
              <Link to="/drivers" className="driverLink" >{intl.formatMessage({ id: 'menu.title.driversShort' })}</Link>
              <FontIcon className="chevron">chevron_right</FontIcon>
              {currentDriver}
            </span>
          );
        }
        return title;
      }
      return '';
    };

    const routes = (
      <Switch>
        <UnauthenticatedRoute path="/login" exact component={Login} props={childProps} />
        <UnauthenticatedRoute path="/forgottenPassword" exact component={Forgot} props={childProps} />
        <AuthenticatedRoute path="/" exact component={RootPage} props={childProps} />
        <Route path="/faq" exact component={Faq} props={childProps} />
        <Route path="/privacy-policy" exact component={Privacy} props={childProps} />

        {navItems({ intl }).map(e => <AuthenticatedRoute key={e.path} exact props={childProps} {...e} />)}
        {/* Finally, catch all unmatched routes */}
        <Route component={NotFound} />
      </Switch>
    );
    const authenticated = (
      <div className="App">
        <Header appTitle={getCurrentTitle()} {...childProps} />
        {routes}
        <Footer />
      </div>
    );


    return (childProps.isAuthenticated ? authenticated : routes);
  }
}

export default injectIntl(withRouter(Routes));



// WEBPACK FOOTER //
// ./src/components/Routes.js